import { render } from "./PainelFormulario.vue?vue&type=template&id=851c3528&scoped=true"
import script from "./PainelFormulario.vue?vue&type=script&lang=js"
export * from "./PainelFormulario.vue?vue&type=script&lang=js"

import "./PainelFormulario.vue?vue&type=style&index=0&id=851c3528&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851c3528"]])

export default __exports__